// src/components/QuestionRenderer.js
import React from 'react';
import MCQRenderer from './renderers/MCQRenderer';
import MultipleResponseRenderer from './renderers/MultipleResponseRenderer';
import TypeInRenderer from './renderers/TypeInRenderer';
import OrderRenderer from './renderers/OrderRenderer';
import MatchingRenderer from './renderers/MatchingRenderer';
import './QuestionRenderer.css';

const QuestionRenderer = ({ 
  question, 
  userAnswer, 
  onAnswerChange, 
  showFeedback = false,
  showCorrectAnswers = false
}) => {
  if (!question) {
    return <div className="no-question">No question data available</div>;
  }

  const commonProps = {
    question,
    userAnswer,
    onAnswerChange,
    showFeedback,
    showCorrectAnswers
  };

  switch (question.questionType) {
    case 'mcq':
      return <MCQRenderer {...commonProps} />;

    case 'multiple-response':
      return <MultipleResponseRenderer {...commonProps} />;

    case 'type-in':
      return <TypeInRenderer {...commonProps} />;

    case 'order':
      return <OrderRenderer {...commonProps} />;

    case 'matching':
      return <MatchingRenderer {...commonProps} />;

    default:
      return (
        <div className="unknown-question-type">
          <p>Unknown question type: {question.questionType}</p>
          <pre>{JSON.stringify(question, null, 2)}</pre>
        </div>
      );
  }
};

export default QuestionRenderer;